import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {CookieModule} from 'ngx-cookie';
import {TooltipModule} from '../tooltip';
import {AuthWithSimulatorCookieGuard} from './auth-with-simulator-cookie.guard';
import {LinkToSimulatorComponent} from './link-to-simulator.component';
import {LinkToSimulatorService} from './link-to-simulator.service';

@NgModule({
    imports: [
        TooltipModule,
        CookieModule.withOptions(),
        CommonModule
    ],
    providers: [
        LinkToSimulatorService,
        AuthWithSimulatorCookieGuard
    ],
    declarations: [
        LinkToSimulatorComponent
    ],
    exports: [
        LinkToSimulatorComponent
    ]
})
export class LinkToSimulatorModule {}
